// extracted by mini-css-extract-plugin
module.exports = {"tech_box":"tech_box-220t-4IT"};